/**
 * Created on 2025-06-13
 */
import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core'
import Switch from '../../../../uiKit/Switch'

const styles = theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 20px 16px 34px',
    backgroundColor: '#fff',
    borderRadius: '10px',
    marginTop: '16px',
    boxShadow: '0px 0px 5.2px 2px #86868626',
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '16px',
    maxWidth: '705px',
  },
  title: {
    fontWeight: '700',
    fontSize: '16px',
    marginBottom: '4px',
    color: '#333333',
  },
  description: {
    fontSize: '14px',
    color: '#7a7a7a',
  },
})

const TwoFactorToggle = ({ classes, enabled, onChange }) => {
  return (
    <div className={classes.container}>
      <div className={classes.iconContainer}>
        <img src="/images/platform/authentication.svg" alt="Authentication icon" />
        <div className={classes.textContainer}>
          <div className={classes.title}>{enabled ? 'Disable two factor authentication' : 'Enable two factor authentication'}</div>
          <div className={classes.description}>
            Two-step authentication (also known as two-factor authentication or 2FA) is a security process in which a
            user provides two different authentication factors to verify their identity. This adds an extra layer of
            security through One Time Passcode (OTP) beyond just a username and password.
          </div>
        </div>
      </div>
      <Switch checked={enabled} onChange={onChange} />
    </div>
  )
}

TwoFactorToggle.propTypes = {
  classes: PropTypes.object.isRequired,
  enabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default withStyles(styles)(TwoFactorToggle)
